import { render, staticRenderFns } from "./OrderContact.vue?vue&type=template&id=7967eb73&scoped=true"
import script from "./OrderContact.vue?vue&type=script&lang=js"
export * from "./OrderContact.vue?vue&type=script&lang=js"
import style0 from "./OrderContact.vue?vue&type=style&index=0&id=7967eb73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.21_vue-t_erapicvfwevmkf5xbebrw2tmey/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967eb73",
  null
  
)

export default component.exports